import Comm from '../services/comm';

function mapError(phpErrors) {
    let errors = [];
    phpErrors.forEach(error => {
        let frontError = null;
        switch (error) {
            case 'Username not set':
                frontError = 'Kérem adjon meg felhasználónevet!';
                break;

            case 'Password not set':
                frontError = 'Kérem adjon meg jelszót!';
                break;

            case 'E-mail not set':
                frontError = 'Kérem adjon meg e-mail címet!';
                break;

            case 'Role not set':
                frontError = 'Kérem válasszon szerepkört!';
                break;
        }

        errors.push(frontError);
    });

    return errors;
}

export default{
    namespaced: true,
    state: {
        roleListLoading: false,
        roleListError: null,
        listLoading: false,
        listError: null,
        dataListLoading: false,
        dataListError: null,
        saveLoading: false,
        saveError: null,
        deleteLoading: false,
        deleteError: null
    },
    actions: {
        getRoleList(context, data){
            context.state.roleListError = null;
            context.state.roleListLoading = true;
            Comm.postData('userroles.php').then(
                res => {
                    data.result(res);
                    context.state.roleListLoading = false;
                },
                rej => {
                    data.reject(rej);
                    context.state.roleListLoading = false;
                }
            )
        },
        getUserList(context, data){
            context.state.listError = null;
            context.state.listLoading = true;
            Comm.postData('users.php').then(
                res => {
                    data.result(res);
                    context.state.listLoading = false;
                },
                rej => {
                    data.reject(rej);
                    context.state.listLoading = false;
                }
            )
        },
        getUserDataList(context, data){
            context.state.dataListError = null;
            context.state.dataListLoading = true;
            Comm.postData('usersdata.php').then(
                res => {
                    data.result(res);
                    context.state.dataListLoading = false;
                },
                rej => {
                    data.reject(rej);
                    context.state.dataListLoading = false;
                }
            )
        },
        saveUser(context, data){
            context.state.saveError = null;
            context.state.saveLoading = true;
            Comm.postData('user.php', {data: data.data}).then(
                res => {
                    if(res.data.status == 'ok'){
                        data.result(res);
                    } else {
                        context.state.saveError = mapError(res.data.errors);
                        data.reject(res);
                    }
                    context.state.saveLoading = false;
                },
                rej => {
                    context.state.saveError = mapError(res.data.errors);
                    data.reject(rej);
                    context.state.saveLoading = false;
                }
            )
        },
        editUser(context, data){
            context.state.saveError = null;
            context.state.saveLoading = true;
            Comm.putData('user.php', {data: data.data}).then(
                res => {
                    if(res.data.status == 'ok'){
                        data.result(res);
                    } else {
                        context.state.saveError = mapError(res.data.errors);
                        data.reject(res);
                    }
                    context.state.saveLoading = false;
                },
                rej => {
                    context.state.saveError = mapError(res.data.errors);
                    data.reject(rej);
                    context.state.saveLoading = false;
                }
            )
        },
        deleteUser(context, data){
            context.state.deleteError = null;
            context.state.deleteLoading = true;
            Comm.deleteData(`user.php?id=${data.id}`).then(
                res => {
                    if(res.data.status === 'ok'){
                        data.result(res);
                    } else {
                        context.deleteError = 'Hiba történt mentés közben, kérem forduljon a rendszergazdához!';
                        data.reject(res);
                    }
                    context.state.deleteLoading = false;
                },
                rej => {
                    context.deleteError = 'Hiba történt mentés közben, kérem forduljon a rendszergazdához!';
                    data.reject(rej);
                    context.state.deleteLoading = false;
                }
            )
        }
    }
}



// WEBPACK FOOTER //
// ./src/store/userStore.js